import React, { useState, useEffect } from "react";
import { Box, Typography } from "@material-ui/core";

import ForgotPasswordFillPopup from "./ForgotPasswordFillPopup";
import OTPConfirmPopup from "src/components/PopUp/PopUpComponents/OTPConfirmPopup";
import ResetPasswordPopup from "src/components/PopUp/ForgotPasswordPopup/ResetPasswordPopup";

import {
  WhitePopup,
  WhitePopupAction,
} from "src/components/PopUp/PopUpComponents/WhitePopup";
import CountdownButton from "src/components/CountdownButton";

interface ForgotPasswordPopupInterface {
  open: boolean;
  handleClose: () => void;
  brokerName?: string;
  brokerID?: string;
  openLogin?: () => void;
}

const ForgotPasswordPopup: React.FC<ForgotPasswordPopupInterface> = ({
  open,
  handleClose,
  brokerName,
  brokerID,
  openLogin,
}) => {
  const [registerState, setRegisterState] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    if (open) setRegisterState(0);
  }, [open]);

  const onSuccessRequestRegister = (phoneNumber: string) => {
    setPhoneNumber(phoneNumber);
    setRegisterState(1);
  };

  const onOtpVerified = () => {
    setRegisterState(2);
  };

  const onResetPasswordSuccess = () => {
    setRegisterState(3);
  };

  const toHome = () => {
    window.location.pathname = "/";
  };

  // const onClose = () => {
  //   setRegisterState(0)
  //   handleClose()
  // }

  const onBack = () => {
    setRegisterState(0);
  };

  const renderWhitePopupConfirm = (
    <WhitePopup
      open={open && registerState === 3}
      // open={true}
      onClose={handleClose}
      color="primary"
      variant="response"
    >
      <Box display="flex" flexDirection="column">
        <Typography
          color="primary"
          variant="h6"
          align="center"
          style={{ fontWeight: 600 }}
        >
          เปลี่ยนรหัสผ่านสำเร็จ
        </Typography>
      </Box>
      <WhitePopupAction>
        <CountdownButton
          startCount={true}
          time={5}
          title={"กลับสู่หน้าแรก"}
          onTimeout={toHome}
          onClick={toHome}
          color="primary"
          textStyle={{ color: "white" }}
          variant="contained"
        />
      </WhitePopupAction>
    </WhitePopup>
  );

  return (
    <Box>
      {renderWhitePopupConfirm}
      <ForgotPasswordFillPopup
        open={open && registerState === 0}
        onClose={handleClose}
        openLogin={openLogin}
        title={`ลืมรหัสผ่าน`}
        onSuccess={onSuccessRequestRegister}
        brokerID={brokerID}
        brokerName={brokerName}
      />
      <OTPConfirmPopup
        open={open && registerState === 1}
        onClose={handleClose}
        onBack={onBack}
        title="ยืนยันหมายเลขโทรศัพท์"
        onSuccess={onOtpVerified}
        phoneNumber={phoneNumber}
        brokerID={brokerID}
        confirmType="requestResetPassword"
      />
      <ResetPasswordPopup
        open={open && registerState === 2}
        onClose={handleClose}
        title="สร้างรหัสผ่านใหม่"
        phoneNumber={phoneNumber}
        brokerID={brokerID}
        brokerName={brokerName}
        onSuccess={onResetPasswordSuccess}
      />
    </Box>
  );
};

export default ForgotPasswordPopup;
